<script setup lang="ts">
import History from "@/views/playground/planner/business-management/settlement-management/revenue/History.vue";
</script>
<template>
  <history></history>
</template>
<style scoped></style>
